import moment from 'moment'

/**
 *
 * @param {string | number} start
 * @param {string | number} end
 * @returns {number} 0 未开始 1 已过期 2 正常
 */
export default function validActivity (start, end) {
  const startMoment = moment(start)
  const endMoment = moment(end)

  if (moment().isBefore(startMoment)) return 0
  if (endMoment.isBefore(moment())) return 1
  return 2
}
